<soft-page [blockScrollY]="true">
  <soft-page-header>
    <div class="">
      Header missing new menu
    </div>
  </soft-page-header>

  <div class="grid grid-cols-[2fr_1fr] h-[100%]">
    <div class="overflow-y-auto">
      <ng-content></ng-content>
    </div>
    <div class="grid grid-rows-[80px_150px_1fr_1fr] gap-2 border-l pl-2">
      <div class="flex flex-col gap-2">
        <div class="flex flex-row justify-between items-center">
          <div>Aufgabe 01</div>
          <div>Status: Offen</div>
        </div>

        <div>
          Erstellt von Dominik Kainz am 04.12.2025
        </div>

      </div>
      <div>
        <div class="soft-overline">Bearbeiter</div>
        <div class="soft-card"></div>
      </div>
      <div>
        <div class="soft-overline">Kommentare</div>
      </div>
      <div>
        <div class="soft-overline">Alle Dateien</div>
      </div>

    </div>
  </div>

</soft-page>
